import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/agency-listing.css";
import * as Listing from "./components/listing";
import { LISTING_MODE } from "./components/listing";
import "core-js/modules/es.array.iterator";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
import CommonModals from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useShareModal } from "@wkComposables/useShareModal";
//@ts-ignore
import BaseComplexToggle from "@vueEntry/UIKitComponents/BaseComplexToggle.vue";
//@ts-ignore
import { COLORS, MAP_TILER_APIKEY } from "@wkWebSrc/js/components/variables";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import PlaceBox from "@vueEntry/PlaceBox.vue";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import { calcPolygonCenter, parsePoints } from "@utils/MapUtils";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
//@ts-ignore
import { getAgenciesData, getMapMarkers } from "@services/agencyAPI";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { createApp, defineAsyncComponent } from "vue";
//@ts-ignore
import { useAgencyFilters } from "@wkComposables/useAgencyFilters";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
import { mapActions, mapState, createPinia } from "pinia";
import { useBaseStore, useSearchBeanStore, useAgencySearchBeanStore, useModalStore, usePublicUserMenuStore, useLoggedUserStore, useMetadataStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { PrestigeIcon } from "@vueEntry/SvgIcons/PrestigeIcon";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { redirect } from "@utils/RedirectUtils";
//@ts-ignore
import BaseCard from "@vueEntry/UIKitComponents/BaseCard.vue";
//@ts-ignore
import ShimmerLoader from "@vueEntry/ShimmerLoader.vue";
//@ts-ignore
import { redirectToApp } from "@utils/AppRedirectUtils";
var insertionHandlerClick = null;
var insertionMediaWrapperClick = null;
var agencyListingApp = createApp({
  name: "WikiAgency",
  components: Object.assign(Object.assign(Object.assign({
    PublicUserMenu,
    PlaceBox,
    BaseButton,
    BaseIcon,
    BaseComplexToggle,
    BaseBtModal,
    BaseBadge,
    BaseDropDown,
    BaseCard,
    ShimmerLoader,
    //@ts-ignore
    "base-tooltip": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseTooltip.vue")),
    //@ts-ignore
    "base-sidebar": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseSidebar.vue")),
    //@ts-ignore
    "map-modal": defineAsyncComponent(() => import("@vmodals/MapModal.vue")),
    //@ts-ignore
    "place-modal": defineAsyncComponent(() => import("@vmodals/PlaceModal.vue")),
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(() => import("./vue/Modals/ContactAgencyModal.vue")),
    //@ts-ignore
    "filters-agency-modal": defineAsyncComponent(() => import("./vue/Modals/FiltersAgencyModal.vue")),
    //@ts-ignore
    "request-prestigious-modal": defineAsyncComponent(() => import("./vue/Modals/RequestPrestigiousModal.vue")),
    PrestigeIcon
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons),
  setup() {
    var {
      displayPhone,
      phoneLabel,
      showPhone
    } = useShowPhone();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      amdLabels,
      amdIcons,
      listingType,
      openContactModal,
      openAndReturnToCAMS
    } = useContactAgencyModal();
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      shareModalData,
      openShareModal,
      gaEvent
    } = useShareModal();
    var {
      search
    } = useSearch();
    var {
      agencyFilter,
      currentSearchName,
      labels
    } = useAgencyFilters();
    var {
      redirectTo
    } = useUtilities();
    var {
      isLarge,
      isDesktopMode
    } = useBreakpoints();
    return {
      isLarge,
      displayPhone,
      phoneLabel,
      showPhone,
      isAppBannerVisible,
      //Contact Agency Modal (CAM)
      //CAM state
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      //CAM computed
      amdLabels,
      amdIcons,
      listingType,
      //CAM methods
      openContactModal,
      openAndReturnToCAMS,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      //useSearch
      search,
      //useShareModal
      shareModalData,
      openShareModal,
      gaEvent,
      //useCommonVars
      agencyFilter,
      currentSearchName,
      labels,
      redirectTo,
      isDesktopMode
    };
  },
  data() {
    return {
      ListingInit: {
        list: "#agencies-with-re-list",
        "buildInfoWindow": buildInfoWindow,
        click: true
      },
      activeMode: "Lista",
      mapInitialized: false,
      customListingTypologyURL: "",
      useContractType: false,
      place: JSON.parse(window["_serializedPlace"]),
      collapsed: true,
      map: null,
      isPrestige: null,
      currentPage: window["_currentPage"],
      previewCardAgencyMap: [],
      isPreviewCardSidebarVisible: false,
      lastMarkersClicked: [],
      popoverVisible: false,
      loadingPreviewCard: false,
      closeSidebar: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    mapRangeForMarkers() {
      return window._freesearch || this.searchBean.placeType == PLACE_TYPE.REGION ? 1000000 : window._mapRange;
    },
    currentSearchFranchiseId() {
      return Number.parseInt(new URLSearchParams(window.location.search).get("Franchise") || "");
    },
    checkedMap() {
      return window.location.hash === "#map";
    },
    checkedList() {
      return !this.checkedMap || window.location.hash === "#list";
    },
    listMode() {
      return this.activeMode === "Lista";
    },
    mapMode() {
      return !this.listMode;
    },
    orderOptions() {
      return window.orderOptions;
    },
    orderSelected() {
      return this.orderOptions.find(option => option.id === this.searchBean.filterOrderId) || {
        id: 0
      };
    },
    polygonPoints() {
      return this.searchBean.polygonFromMap ? parsePoints(this.searchBean.polygonFromMap) : [];
    },
    currentMapCenter() {
      var _a, _b;
      return this.searchBean.polygonFromMap ? calcPolygonCenter(this.polygonPoints) : {
        lat: ((_a = this.place) === null || _a === void 0 ? void 0 : _a.latitude) || 42.4153262,
        lng: ((_b = this.place) === null || _b === void 0 ? void 0 : _b.longitude) || 12.6428742
      };
    },
    agencySearchBean() {
      return JSON.parse(window["_serializedAgencySearchBean"]);
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])), mapState(useSearchBeanStore, ["searchBean"])), mapState(useAgencySearchBeanStore, ["searchBeanAgency"])), mapState(useMetadataStore, ["pageName"])),
  watch: {
    activeMode: {
      handler(cur) {
        var _a, _b, _c, _d;
        if (cur === LISTING_MODE.MAP) {
          sendGAEvent("agency_listing_view", {
            view_type: "map",
            event_location: this.pageName
          });
          (_a = this.$refs.mapButton) === null || _a === void 0 ? void 0 : _a.classList.add("tw-hidden");
          (_b = this.$refs.listButton) === null || _b === void 0 ? void 0 : _b.classList.remove("tw-hidden");
          this.$refs.footer.classList.add("tw-hidden");
          this.$refs.footer.classList.remove("tw-block");
          window.history.pushState(Date.now(), "", "#map");
          if (!this.mapInitialized) {
            this.initMap();
            this.mapInitialized = true;
          } else window.dispatchEvent(new Event("resize"));
        } else {
          sendGAEvent("agency_listing_view", {
            view_type: "default",
            event_location: this.pageName
          });
          window.history.pushState(Date.now(), "", "#list");
          (_c = this.$refs.listButton) === null || _c === void 0 ? void 0 : _c.classList.add("tw-hidden");
          (_d = this.$refs.mapButton) === null || _d === void 0 ? void 0 : _d.classList.remove("tw-hidden");
          this.$refs.footer.classList.add("tw-block");
          this.$refs.footer.classList.remove("tw-hidden");
        }
      },
      deep: true
    }
  },
  created() {
    this.checkedList && sendGAEvent("agency_listing_view", {
      view_type: "default",
      event_location: this.pageName
    });
    var _url = new URL(window.location.href);
    var queryParams = new URLSearchParams(_url.search);
    if (queryParams.get("Pregio") === "true") {
      this.isPrestige = true;
    } else if (queryParams.get("Pregio") === "false") this.isPrestige = false;
    this.initPublicUserMenu();
    this.updateAgencySearchBean(Object.assign(Object.assign({}, this.agencySearchBean), {
      isPrestigious: this.isPrestige
    }));
    //this because the search() is based on the searchBean and needed some changes to make it works with the agencySearchBean
    this.updateSearchBean(this.agencySearchBean);
    this.customListingTypologyURL = this.labels.macroTypology_url_5;
    if (this.currentSearchName || this.currentSearchFranchiseId) {
      this.agencyFilter = {
        name: this.currentSearchName,
        franchiseId: this.currentSearchFranchiseId
      };
    }
    //default set to disclaimer
    this.openModal("AG_DISCLAIMER_MODAL");
  },
  mounted() {
    hideNavigationBreadcrumb();
    Listing.init({
      list: "#list-agencies",
      buildInfoWindow: buildInfoWindow
    });
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    handleBreadcrumbLinkClick,
    handleInsertionClick,
    useApp() {
      redirectToApp("Listato agenzie  - Banner");
    },
    searchAgencies(agencyFilters) {
      var fromPrestigeButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.search(true, this.labels.macroTypology_url_5, false, agencyFilters);
    },
    isPrestigeClick() {
      var urlString = window.location.href;
      var _url = new URL(window.location.href);
      var params = new URLSearchParams(_url.search);
      if (params.get("p")) {
        // if page > 1 stop - REFACTOR when prestigious agencies will reach 2+ pages
        if (!this.isPrestige) {
          this.isPrestige = true;
          params.delete("p");
          params.set("Pregio", "true");
        } else {
          params.delete("Pregio");
          this.isPrestige = false;
        }
        urlString = this.isPrestige ? "".concat(_url.origin).concat(_url.pathname, "?").concat(params) : "".concat(_url.origin).concat(_url.pathname);
        this.updateAgencySearchBean({
          isPrestigious: this.isPrestige
        });
        window.location.href = urlString;
        return;
      }
      urlString = _url.search !== "" ? "".concat(_url.origin).concat(_url.pathname).concat(_url.search) // https://local.wikicasa.it:8443 + /agenzie-immobiliari/ricerca/ + ?filtro1&filtro2
      : "".concat(_url.origin).concat(_url.pathname); // https://local.wikicasa.it:8443 + /agenzie-immobiliari/ricerca/
      this.isPrestige = !this.isPrestige;
      params.set("Pregio", "".concat(this.isPrestige));
      urlString = "".concat(_url.origin).concat(_url.pathname, "?").concat(params);
      this.updateAgencySearchBean({
        isPrestigious: this.isPrestige
      });
      window.location.href = urlString;
    },
    saveFilterAgency(agencyFilter) {
      this.agencyFilter = Object.assign({}, agencyFilter);
    },
    openModal(modalName) {
      this.setShowModal(modalName);
    },
    closeModal(modalName) {
      this.setShowModal(Modals.noModal);
    },
    setActiveMode(newMode) {
      this.activeMode = newMode;
    },
    openURL(agency) {
      redirect({
        url: "".concat(window["_baseURL"]).concat(agency.url),
        blankPage: {
          lg: true
        }
      });
    },
    initMap() {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        var [leafletModule, leafletCSSModule, mapCSSModule, swiperModule] = yield Promise.all([
        //@ts-ignore
        import( /* webpackChunkName: "chunks/leaflet_map" */"@wkWebSrc/js/LeafletMap/leaflet_map"), require( /* webpackChunkName: "chunks/leaflet_theme" */"../style/vendor/leafleft.theme.css"), require( /* webpackChunkName: "chunks/map" */"../style/layout/map.css"), import("swiper"),
        //@ts-ignore
        import("swiper/css")]);
        var LeafletMap = leafletModule.default;
        this.map = new LeafletMap();
        var map_selector = this.$refs.listingMapPlaceholder;
        try {
          yield (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(map_selector, MAP_TILER_APIKEY, COLORS, this.isDesktopMode ? 12 : 11);
          if (!this.isDesktopMode) {
            this.map.addListener(this.map.getMap(), "click", () => {
              var _a, _b;
              this.isPreviewCardSidebarVisible = false;
              this.loadingPreviewCard = false;
              (_a = document.getElementById("open-map-modal-btn-mobile")) === null || _a === void 0 ? void 0 : _a.classList.add("is-transitioned");
              (_b = document.getElementById("save-search-button-mobile")) === null || _b === void 0 ? void 0 : _b.classList.add("is-transitioned");
            });
          }
          this.map.startSpinner();
          this.ListingInit.getMapMarkers = () => __awaiter(this, void 0, void 0, function* () {
            yield getMapMarkers(this.searchBeanAgency).then(markers => {
              var _a, _b;
              if (this.polygonPoints.length) {
                (_a = this.map) === null || _a === void 0 ? void 0 : _a.deleteShape();
                (_b = this.map) === null || _b === void 0 ? void 0 : _b.drawPolygonFromPoints(this.polygonPoints);
              }
              if (markers.length > 0) {
                this.map.initMarkerClusterer();
                this.map.addMarkerBulk(markers, this.currentMapCenter, this.mapRangeForMarkers);
              }
              if (this.map.hasShape()) this.map.fitBounds(this.map.getShape().getBounds());else if (this.map.getMarkersCount()) this.map.fitBounds(this.map.getMarkerClusterer().getBounds());
              this.map.getMap().invalidateSize();
              this.map.on("click movestart", () => {
                if (this.isDesktopMode) this.closeSidebar = true;
              });
              this.map.addListener(this.map.getMarkerClusterer(), "click", e => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                var marker = e.propagatedFrom;
                if (!this.isDesktopMode) {
                  (_c = document.getElementById("open-map-modal-btn-mobile")) === null || _c === void 0 ? void 0 : _c.classList.add("is-transitioned");
                  (_d = document.getElementById("save-search-button-mobile")) === null || _d === void 0 ? void 0 : _d.classList.add("is-transitioned");
                  this.map.setCenter(marker.getLatLng().lat, marker.getLatLng().lng, this.map.getZoom());
                  //this is needed because the map is not centered correctly on mobile devices that have a height less than 770px
                  if (innerHeight < 770) {
                    var space = 0.0005;
                    var lat = +(marker.getLatLng().lat - space).toFixed(6);
                    this.map.setCenter(lat, marker.getLatLng().lng, 18);
                  } else this.map.setCenter(marker.getLatLng().lat, marker.getLatLng().lng, this.map.getZoom());
                }
                this.isPreviewCardSidebarVisible = true;
                try {
                  if (this.lastMarkersClicked.find(id => marker["id"].includes(id))) {
                    this.loadingPreviewCard = true;
                    return;
                  }
                  this.loadingPreviewCard = false;
                  this.lastMarkersClicked = [];
                  this.lastMarkersClicked.push(...marker["id"]);
                  this.previewCardAgencyMap = yield buildInfoWindow(marker["id"]);
                  this.loadingPreviewCard = true;
                } catch (e) {
                  console.error(e);
                }
              }));
            }).finally(() => {
              this.map.stopSpinner();
            });
          });
        } catch (e) {
          console.error(e);
        }
        yield this.ListingInit.getMapMarkers();
      });
    },
    collapse() {
      this.collapsed = !this.collapsed;
    }
  }, mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useSearchBeanStore, ["updateSearchBean"])), mapActions(useAgencySearchBeanStore, ["updateAgencySearchBean"])), mapActions(useModalStore, ["setShowModal"]))
});
agencyListingApp.use(createPinia());
agencyListingApp.mount("#agency-main");
var handleMapInsertionClick = () => {
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  var _loop = function _loop() {
    insertionMediaWrapperClick = e => e.preventDefault();
    //Avoid catching from children elements
    mediaWrapperEl.addEventListener("click", insertionMediaWrapperClick);
    var insertionMapEl = mediaWrapperEl.parentElement;
    if (!insertionMapEl) return 1; // continue
    var {
      url
    } = insertionMapEl.dataset;
    insertionHandlerClick = () => {
      handleInsertionClick({
        url: url || "",
        blankPage: {
          lg: true
        }
      });
    };
    //Adding insertion on click handler
    insertionMapEl.addEventListener("click", insertionHandlerClick);
  };
  for (var mediaWrapperEl of mediaWrapperList) {
    if (_loop()) continue;
  }
};
var removeMapInsertionClickListener = () => {
  var _a;
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  for (var mediaWrapperEl of mediaWrapperList) {
    insertionMediaWrapperClick && mediaWrapperEl.removeEventListener("click", insertionMediaWrapperClick);
    insertionHandlerClick && ((_a = mediaWrapperEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", insertionHandlerClick));
  }
  insertionHandlerClick = null;
  insertionMediaWrapperClick = null;
};
document.addEventListener("info-event-created", handleMapInsertionClick);
function hideNavigationBreadcrumb() {
  document.addEventListener("scroll", () => {
    [document.getElementById("navigation-dropdown-breadcrump"), document.getElementById("navigation-dropdown-breadcrump-franchise")].forEach(el => el === null || el === void 0 ? void 0 : el.classList.remove("show"));
  });
}
function buildInfoWindow(ids) {
  return __awaiter(this, void 0, void 0, function* () {
    try {
      var data = yield getAgenciesData({
        "agencyIdList": ids
      });
      if (!data) return [];
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  });
}